import React, { useEffect, useMemo, useState } from "react";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import { useFetchBorosilUserPointHistoryMutation } from "../../../features/tenant/Borosil/SalesBoosterHistoryBorosilApi";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import toast from "react-hot-toast";
import { formatter } from "../../../utils/numberFormatter";
import AnimatedNumber from "../../../components/AnimatedNumber/AnimatedNumber";
import { MdPerson } from "react-icons/md";
import CustomOnlyDownloadExport from "../../../components/CustomExport/CustomOnlyDownloadExport";
const FINANCIAL_YEARS = ["2026-2027", "2025-2026"];

const BorosilUserHistorySearch = () => {
    const zoneId = getLoginUserData().zone_id;
    const [
        borosilPointHistory,
        {
            data: pointsHistoryData,
            error: pointsHistoryError,
            isLoading: pointsHistoryIsLoading,
        },
    ] = useFetchBorosilUserPointHistoryMutation();

    const [
        fetchPointsScanHistoryCsv,
        { data: pointsScanHistoryCsvData, error: pointsScanHistoryCsvError },
    ] = useFetchBorosilUserPointHistoryMutation();

    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [lineWiseData, setLineWiseData] = useState([]);
    const [divisionData, setDivisionData] = useState([])


    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const initialRequest = {
        limit: 10,
        offset: 0,
        mobile: "",
        name: "",
        user_id: "",
    };
    const [request, setRequest] = useState(initialRequest);

    const clearFilters = () => {
        setRequest(initialRequest);
        setMyList([]);
        setTotalRows(0);
    };

    useEffect(() => {
        if (request.mobile && request.mobile.length == 10) {
            fetchPointsScanHistoryFunction();
        }
    }, [request]);

    useEffect(() => {
        if (limit != 10 || offset != 0) fetchPointsScanHistoryFunction();
        // fetchCsvPointsScanHistoryFunction();
    }, [limit, offset]);

    const fetchPointsScanHistoryFunction = async () => {
        const response = await borosilPointHistory({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: request,
        }).unwrap();

        return response?.body?.data;
    };

    const fetchCsvPointsScanHistoryFunction = () => {
        const modifiedRequest = {
            ...request,
            limit: null,
            offset: null,
        };
        fetchPointsScanHistoryCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: modifiedRequest,
            zone_id: zoneId,
        });
    };

    const [csvData, setCsvData] = useState(null);
    useEffect(() => {
        if (pointsScanHistoryCsvData && pointsScanHistoryCsvData?.body?.data) {
            setCsvData(pointsScanHistoryCsvData?.body?.data);
        }

        if (pointsScanHistoryCsvError) {
            setCsvData(null);
        }
    }, [pointsScanHistoryCsvData, pointsScanHistoryCsvError]);

    useEffect(() => {
        if (pointsHistoryData && pointsHistoryData?.body) {
            toast.dismiss();
            console.log("success scan history", pointsHistoryData);
            setMyList(
                pointsHistoryData.body && pointsHistoryData.body.data
                    ? pointsHistoryData.body.data
                    : [],
            );
            setLineWiseData(pointsHistoryData.body && pointsHistoryData.body.line_wise_data
                ? pointsHistoryData.body.line_wise_data
                : [])

            setTotalRows(
                pointsHistoryData.body && pointsHistoryData.body.total
                    ? pointsHistoryData.body.total
                    : 0,
            );
            setDivisionData(pointsHistoryData.body && pointsHistoryData.body.division_wise_data
                ? [...pointsHistoryData.body.division_wise_data].sort((a, b) =>
                    (a.division_name || "").localeCompare(b.division_name || "")
                )
                : [])
        }
        if (pointsHistoryError) {
            toast.dismiss();
            console.error("pointsHistoryError", pointsHistoryError);
            if (pointsHistoryError && pointsHistoryError?.data) {
                toast.error(`${pointsHistoryError?.data?.message}`, {
                    id: "pointsHistoryError",
                });
            } else {
                toast.error("Something went wrong.", {
                    id: "pointsHistoryError",
                });
            }
            setMyList([]);
            setTotalRows(0);
        }

        if (pointsHistoryIsLoading) {
            toast.loading("Please wait..", { id: "pointsHistoryIsLoading" });
        }
    }, [pointsHistoryData, pointsHistoryError, pointsHistoryIsLoading]);

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };
    const columns = [
        {
            name: <span className="font-bold">SNo</span>,
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: <span className="font-bold">Type</span>,
            cell: (row) => (row?.type ? row.type : "Order"),
            sortable: true,
            width: "150px",
        },
        {
            name: <span className="font-bold">Financial Year</span>,
            cell: (row) => (row?.financial_year ? row.financial_year : "Not Applicable"),
            sortable: true,
            width: "150px",
        },
        {
            name: <span className="font-bold">Voucher Date</span>,
            cell: (row) =>
                row?.voucher_date &&
                new Date(row.voucher_date).toLocaleDateString(),
            sortable: true,
            width: "150px",
        },
        {
            name: <span className="font-bold">Voucher No</span>,
            cell: (row) => (row.voucher_no ? row.voucher_no : "Not Applicable"),
            sortable: true,
            width: "150px",
        },
        {
            name: <span className="font-bold">Points</span>,
            cell: (row) => row.points,
            sortable: true,
            width: "120px",
        },
        {
            name: <span className="font-bold">Value / Purchase Amount</span>,
            cell: (row) =>
                row?.value
                    ? row.value
                    : row?.purchase_amount
                        ? row?.purchase_amount
                        : "Not Applicable",
            sortable: true,
        },
        {
            name: <span className="font-bold">Remarks</span>,
            cell: (row) => row.remarks,
            sortable: true,
        },
        {
            name: <span className="font-bold">Created At</span>,
            cell: (row) => new Date(row.created_at).toLocaleString(),
            width: "120px",
            sortable: true,
        },
    ];


    const [userValues, setUserValues] = useState({
        total_points: 0,
        total_purchase_value: 0,
    });

    const totals = useMemo(() => {
        return myList.reduce(
            (acc, curr) => {
                if (curr?.cause) {
                    if (curr?.cause?.type !== 'sales_booster_redeemed') {
                        acc.total_points += Number(curr.points || 0);
                    }
                } else {
                    acc.total_points += Number(curr.points || 0);
                    acc.total_purchase_value += Number(
                        curr.purchase_amount || 0,
                    );
                }
                return acc;
            },
            { total_points: 0, total_purchase_value: 0 },
        );
    }, [myList]);

    const totalsByFY = useMemo(() => {
        return myList.reduce((acc, curr) => {
            const fy = curr?.financial_year || "Unknown";

            if (!acc[fy]) {
                acc[fy] = { total_points: 0, total_purchase_value: 0 };
            }

            if (curr?.cause) {
                if (curr?.cause?.type !== 'sales_booster_redeemed' && curr?.cause?.type !== 'carry_forwarded_points') {
                    acc[fy].total_points += Number(curr.points || 0);
                }
            } else {
                acc[fy].total_points += Number(curr.points || 0);
                acc[fy].total_purchase_value += Number(curr.purchase_amount || 0);
            }
            return acc;
        }, {});
    }, [myList]);

    const totalsByCauseType = useMemo(() => {
        return myList.reduce((acc, curr) => {
            const causeType = curr?.type ? curr.type : "Order";
            const fy = curr?.financial_year || "Unknown";

            if (!acc[causeType]) {
                acc[causeType] = {};
            }
            if (!acc[causeType][fy]) {
                acc[causeType][fy] = {
                    total_points: 0,
                };
            }
            acc[causeType][fy].total_points += Number(curr.points || 0);
            return acc;
        }, {});
    }, [myList]);

    const getCauseTypeTotal = (causeType) => {
        let total = 0;
        if (totalsByCauseType[causeType]) {
            Object.values(totalsByCauseType[causeType]).forEach(fyData => {
                total += fyData.total_points;
            });
        }
        return total;
    };



    const totalsByRank = useMemo(() => {
        return lineWiseData.reduce((acc, curr) => {
            const brand = curr?.brand_name;
            const rank = curr?.rank;
            const fy = curr?.financial_year || "Unknown";

            if (!acc[brand]) acc[brand] = {};
            if (!acc[brand][rank]) acc[brand][rank] = {};

            if (!acc[brand][rank][fy]) {
                acc[brand][rank][fy] = {
                    total_points: 0,
                    total_value: 0,
                    total_qty: 0,
                };
            }

            acc[brand][rank][fy].total_points += Number(curr.total_points || 0);
            acc[brand][rank][fy].total_value += Number(curr.total_value || 0);
            acc[brand][rank][fy].total_purchase += Number(curr.total_qty || 0);

            return acc;
        }, {});
    }, [lineWiseData]);

    const getRankTotal = (rank) => {
        let total_points = 0;
        let total_value = 0;

        Object.values(totalsByRank).forEach((brandData) => {
            if (brandData[rank]) {
                Object.values(brandData[rank]).forEach((fyData) => {
                    total_points += fyData.total_points;
                    total_value += fyData.total_value;
                });
            }
        });

        return { total_points, total_value };
    };

    useEffect(() => {
        setUserValues(totals);
    }, [totals]);

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        User Search
                        <LinksComponent />
                    </div>

                    <div className=" mx-auto px-3 py-3">
                        {/* Search Card */}
                        <div className="bg-white rounded-md shadow-lg border border-gray-200 overflow-hidden mb-6">
                            <div className=" border-b border-gray-200 px-6 py-4 pb-2">
                                {/* <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                                </svg>
                                Search Filters
                            </h2> */}

                                {/* Search Inputs */}
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-1">
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Name
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <MdPerson />
                                            </div>
                                            <input
                                                type="search"
                                                className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                placeholder="Enter name..."
                                                value={request.name}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;

                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        name: newValue?.trim(),
                                                        user_id: "",
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Mobile Number
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                </svg>
                                            </div>
                                            <input
                                                type="search"
                                                className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                placeholder="Enter mobile number..."
                                                value={request.mobile}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        mobile: newValue,
                                                        user_id: "",
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            User ID
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                            </div>
                                            <input
                                                type="search"
                                                className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                placeholder="Enter user ID..."
                                                value={request.user_id}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        user_id: newValue,
                                                        mobile: "",
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex items-end gap-2">
                                        <button
                                            onClick={fetchPointsScanHistoryFunction}
                                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                        >
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                            </svg>
                                            Search
                                        </button>
                                        <button
                                            onClick={clearFilters}
                                            className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                        >
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                            </svg>
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {myList.length > 0 && (
                                <div className="p-6 pt-2">
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                                        <div className="space-y-4">
                                            {/* SKU Category Stats Redesign */}
                                            <div>
                                                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                                    </svg>
                                                    SKU Category Stats
                                                </h3>

                                                <div className="space-y-6">
                                                    {/* High Selling SKU Table */}
                                                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                                                        <div className="bg-blue-50 px-4 py-3 border-b border-gray-200 flex justify-between items-center">
                                                            <h3 className="font-semibold text-blue-800">High Selling SKU</h3>
                                                            <div className="text-right">
                                                                <p className="text-[10px] text-blue-500 font-bold uppercase tracking-wider">Total Value</p>
                                                                <p className="text-sm font-bold text-blue-700">₹{formatter.format(getRankTotal("2.00").total_value)}</p>
                                                            </div>
                                                        </div>
                                                        <div className="overflow-x-auto">
                                                            <table className="w-full text-sm text-left">
                                                                <thead className="bg-gray-50 text-gray-600 text-xs uppercase border-b">
                                                                    <tr>
                                                                        <th className="px-4 py-2 font-medium">Brand</th>
                                                                        {FINANCIAL_YEARS.map(fy => (
                                                                            <th key={fy} className="px-4 py-2 font-medium text-center border-l">{fy}</th>
                                                                        ))}
                                                                        <th className="px-4 py-2 font-medium text-center border-l bg-gray-100">Brand Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="divide-y divide-gray-100">
                                                                    {["Borosil", "Larah"].map((brand) => {
                                                                        const brandTotalPts = FINANCIAL_YEARS.reduce((sum, fy) => sum + (totalsByRank[brand]?.["2.00"]?.[fy]?.total_points || 0), 0);
                                                                        const brandTotalVal = FINANCIAL_YEARS.reduce((sum, fy) => sum + (totalsByRank[brand]?.["2.00"]?.[fy]?.total_value || 0), 0);
                                                                        return (
                                                                            <tr key={brand} className="hover:bg-gray-50/50">
                                                                                <td className="px-4 py-3 font-semibold text-gray-800">{brand}</td>
                                                                                {FINANCIAL_YEARS.map((fy) => {
                                                                                    const data = totalsByRank[brand]?.["2.00"]?.[fy] || { total_points: 0, total_value: 0 };
                                                                                    return (
                                                                                        <td key={fy} className="px-4 py-3 border-l text-center">
                                                                                            <div className="flex flex-col items-center gap-1">
                                                                                                <span className="text-xs text-gray-500">Value: <span className="font-bold text-gray-900">₹{formatter.format(data.total_value ?? 0)}</span></span>
                                                                                                <span className="text-xs text-gray-500">Pts: <span className="font-bold text-blue-600">{formatter.format(data.total_points ?? 0)}</span></span>
                                                                                            </div>
                                                                                        </td>
                                                                                    );
                                                                                })}
                                                                                <td className="px-4 py-3 border-l text-center bg-gray-50/80">
                                                                                    <div className="flex flex-col items-center gap-1">
                                                                                        <span className="text-xs text-gray-600">Value: <span className="font-bold text-blue-800">₹{formatter.format(brandTotalVal)}</span></span>
                                                                                        <span className="text-xs text-gray-600">Pts: <span className="font-bold text-blue-800">{formatter.format(brandTotalPts)}</span></span>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                    <tr className="bg-gray-50 font-bold border-t-2 border-gray-200">
                                                                        <td className="px-4 py-3 text-gray-800">Year Total</td>
                                                                        {FINANCIAL_YEARS.map(fy => {
                                                                            const fyTotalPts = ["Borosil", "Larah"].reduce((sum, b) => sum + (totalsByRank[b]?.["2.00"]?.[fy]?.total_points || 0), 0);
                                                                            const fyTotalVal = ["Borosil", "Larah"].reduce((sum, b) => sum + (totalsByRank[b]?.["2.00"]?.[fy]?.total_value || 0), 0);
                                                                            return (
                                                                                <td key={fy} className="px-4 py-3 border-l text-center">
                                                                                    <div className="flex flex-col items-center gap-1">
                                                                                        <span className="text-xs text-gray-600">Value: <span className="font-bold text-blue-800">₹{formatter.format(fyTotalVal)}</span></span>
                                                                                        <span className="text-xs text-gray-600">Pts: <span className="font-bold text-blue-800">{formatter.format(fyTotalPts)}</span></span>
                                                                                    </div>
                                                                                </td>
                                                                            );
                                                                        })}
                                                                        <td className="px-4 py-3 border-l text-center bg-blue-100/50">
                                                                            <div className="flex flex-col items-center gap-1">
                                                                                <span className="text-xs text-gray-700">Value: <span className="font-bold text-blue-900">₹{formatter.format(getRankTotal("2.00").total_value)}</span></span>
                                                                                <span className="text-xs text-gray-700">Pts: <span className="font-bold text-blue-900">{formatter.format(getRankTotal("2.00").total_points)}</span></span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    {/* Normal Selling SKU Table */}
                                                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                                                        <div className="bg-purple-50 px-4 py-3 border-b border-gray-200 flex justify-between items-center">
                                                            <h3 className="font-semibold text-purple-800">Normal Selling SKU</h3>
                                                            <div className="text-right">
                                                                <p className="text-[10px] text-purple-500 font-bold uppercase tracking-wider">Total Value</p>
                                                                <p className="text-sm font-bold text-purple-700">₹{formatter.format(getRankTotal("1.00").total_value)}</p>
                                                            </div>
                                                        </div>
                                                        <div className="overflow-x-auto">
                                                            <table className="w-full text-sm text-left">
                                                                <thead className="bg-gray-50 text-gray-600 text-xs uppercase border-b">
                                                                    <tr>
                                                                        <th className="px-4 py-2 font-medium">Brand</th>
                                                                        {FINANCIAL_YEARS.map(fy => (
                                                                            <th key={fy} className="px-4 py-2 font-medium text-center border-l">{fy}</th>
                                                                        ))}
                                                                        <th className="px-4 py-2 font-medium text-center border-l bg-gray-100">Brand Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="divide-y divide-gray-100">
                                                                    {["Borosil", "Larah"].map((brand) => {
                                                                        const brandTotalPts = FINANCIAL_YEARS.reduce((sum, fy) => sum + (totalsByRank[brand]?.["1.00"]?.[fy]?.total_points || 0), 0);
                                                                        const brandTotalVal = FINANCIAL_YEARS.reduce((sum, fy) => sum + (totalsByRank[brand]?.["1.00"]?.[fy]?.total_value || 0), 0);
                                                                        return (
                                                                            <tr key={brand} className="hover:bg-gray-50/50">
                                                                                <td className="px-4 py-3 font-semibold text-gray-800">{brand}</td>
                                                                                {FINANCIAL_YEARS.map((fy) => {
                                                                                    const data = totalsByRank[brand]?.["1.00"]?.[fy] || { total_points: 0, total_value: 0 };
                                                                                    return (
                                                                                        <td key={fy} className="px-4 py-3 border-l text-center">
                                                                                            <div className="flex flex-col items-center gap-1">
                                                                                                <span className="text-xs text-gray-500">Value: <span className="font-bold text-gray-900">₹{formatter.format(data.total_value ?? 0)}</span></span>
                                                                                                <span className="text-xs text-gray-500">Pts: <span className="font-bold text-purple-600">{formatter.format(data.total_points ?? 0)}</span></span>
                                                                                            </div>
                                                                                        </td>
                                                                                    );
                                                                                })}
                                                                                <td className="px-4 py-3 border-l text-center bg-gray-50/80">
                                                                                    <div className="flex flex-col items-center gap-1">
                                                                                        <span className="text-xs text-gray-600">Value: <span className="font-bold text-purple-800">₹{formatter.format(brandTotalVal)}</span></span>
                                                                                        <span className="text-xs text-gray-600">Pts: <span className="font-bold text-purple-800">{formatter.format(brandTotalPts)}</span></span>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                    <tr className="bg-gray-50 font-bold border-t-2 border-gray-200">
                                                                        <td className="px-4 py-3 text-gray-800">Year Total</td>
                                                                        {FINANCIAL_YEARS.map(fy => {
                                                                            const fyTotalPts = ["Borosil", "Larah"].reduce((sum, b) => sum + (totalsByRank[b]?.["1.00"]?.[fy]?.total_points || 0), 0);
                                                                            const fyTotalVal = ["Borosil", "Larah"].reduce((sum, b) => sum + (totalsByRank[b]?.["1.00"]?.[fy]?.total_value || 0), 0);
                                                                            return (
                                                                                <td key={fy} className="px-4 py-3 border-l text-center">
                                                                                    <div className="flex flex-col items-center gap-1">
                                                                                        <span className="text-xs text-gray-600">Value: <span className="font-bold text-purple-800">₹{formatter.format(fyTotalVal)}</span></span>
                                                                                        <span className="text-xs text-gray-600">Pts: <span className="font-bold text-purple-800">{formatter.format(fyTotalPts)}</span></span>
                                                                                    </div>
                                                                                </td>
                                                                            );
                                                                        })}
                                                                        <td className="px-4 py-3 border-l text-center bg-purple-100/50">
                                                                            <div className="flex flex-col items-center gap-1">
                                                                                <span className="text-xs text-gray-700">Value: <span className="font-bold text-purple-900">₹{formatter.format(getRankTotal("1.00").total_value)}</span></span>
                                                                                <span className="text-xs text-gray-700">Pts: <span className="font-bold text-purple-900">{formatter.format(getRankTotal("1.00").total_points)}</span></span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="space-y-6">
                                            {/* Primary Stats Redesign */}
                                            <div>
                                                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                                    </svg>
                                                    Primary Stats (All Time)
                                                </h3>
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm flex flex-col h-full bg-gradient-to-r from-red-50 to-red-100">
                                                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Total Points Earned</p>
                                                        <AnimatedNumber
                                                            value={Object.values(totalsByFY ?? {}).reduce((acc, curr) => acc + Number(curr?.total_points ?? 0), 0)}
                                                            //value={Object.values(totalsByFY)[0]?.total_points ?? 0}
                                                            //value={userValues.total_points}
                                                            formatter={formatter.format}
                                                            className="text-2xl font-bold text-red-600 mb-auto"
                                                            duration={1}
                                                        />

                                                        {/* FY Breakdown for Points */}
                                                        <div className="mt-4 pt-3 border-t border-gray-100 space-y-2">
                                                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">FY Breakdown</p>
                                                            {FINANCIAL_YEARS.map(fy => (
                                                                <div key={fy} className="flex justify-between items-center text-sm">
                                                                    <span className="text-gray-500 font-medium">{fy}</span>
                                                                    <span className="font-semibold text-red-500">
                                                                        <AnimatedNumber value={totalsByFY[fy]?.total_points ?? 0} formatter={formatter.format} duration={1} />
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <div className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm flex flex-col h-full bg-gradient-to-r from-green-50 to-green-100">
                                                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Total Purchase Value</p>
                                                        <div className="text-2xl font-bold text-green-600 mb-auto">
                                                            ₹<AnimatedNumber
                                                                value={userValues.total_purchase_value}
                                                                formatter={formatter.format}
                                                                className="inline"
                                                                duration={1}
                                                            />
                                                        </div>

                                                        {/* FY Breakdown for Purchase Value */}
                                                        <div className="mt-4 pt-3 border-t border-gray-100 space-y-2">
                                                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">FY Breakdown</p>
                                                            {FINANCIAL_YEARS.map(fy => (
                                                                <div key={fy} className="flex justify-between items-center text-sm">
                                                                    <span className="text-gray-500 font-medium">{fy}</span>
                                                                    <span className="font-semibold text-green-500">
                                                                        ₹<AnimatedNumber value={totalsByFY[fy]?.total_purchase_value ?? 0} formatter={formatter.format} duration={1} className="inline" />
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Points by Category Table */}
                                            {Object.keys(totalsByCauseType).length > 0 && (
                                                <div>
                                                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                                        <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                                        </svg>
                                                        Points by Category
                                                    </h3>
                                                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                                                        <div className="overflow-x-auto">
                                                            <table className="w-full text-sm text-left">
                                                                <thead className="bg-gray-50 text-gray-600 text-xs uppercase border-b">
                                                                    <tr>
                                                                        <th className="px-4 py-3 font-medium">Category</th>
                                                                        {FINANCIAL_YEARS.map(fy => (
                                                                            <th key={fy} className="px-4 py-3 font-medium text-center border-l">{fy}</th>
                                                                        ))}
                                                                        <th className="px-4 py-3 font-medium text-right border-l bg-gray-100">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="divide-y divide-gray-100">
                                                                    {Object.entries(totalsByCauseType).map(([causeType, fyData]) => (
                                                                        <tr key={causeType} className="hover:bg-gray-50/50">
                                                                            <td className="px-4 py-3">
                                                                                <div className="font-semibold text-indigo-800 capitalize">
                                                                                    {causeType.replace(/_/g, " ")}
                                                                                </div>
                                                                                {causeType === 'sales_booster_redeemed' && (
                                                                                    <div className="text-[10px] text-gray-400 mt-0.5">Not in Total Points</div>
                                                                                )}
                                                                            </td>
                                                                            {FINANCIAL_YEARS.map((fy) => (
                                                                                <td key={fy} className="px-4 py-3 border-l text-center font-medium text-gray-700">
                                                                                    {formatter.format(fyData[fy]?.total_points ?? 0)}
                                                                                </td>
                                                                            ))}
                                                                            <td className="px-4 py-3 border-l text-right font-bold text-indigo-600 bg-gray-50/50">
                                                                                {formatter.format(getCauseTypeTotal(causeType))}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>

                        {/* Data Table */}
                        <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                            <div className="border-b flex justify-between items-center border-gray-200 bg-gray-50 px-6 py-4">
                                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    History
                                    {totalRows > 0 && (
                                        <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                            {totalRows} records
                                        </span>
                                    )}
                                </h2>

                                <CustomOnlyDownloadExport
                                    defaultColumns={["name", "user_id", "mobile", "type", "voucher_date", "voucher_no", "points", "purchase_amount", "remarks", "created_at"]}
                                    buttonClassname="btn h-10"
                                    fetchData={fetchPointsScanHistoryFunction}
                                    filename="Records"
                                    label="Download Records"
                                    formatColumns={[
                                        "type",
                                        "voucher_date",
                                        "voucher_no",
                                        "points",
                                        "created_at"
                                    ]}
                                />
                            </div>

                            <div className="relative">
                                {pointsHistoryIsLoading && (
                                    <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
                                        <CircleLoaderComponent />
                                    </div>
                                )}
                                <DataTableComponent
                                    keyField={(row) => row.SNo}
                                    columns={columns}
                                    data={myList}
                                    totalRows={totalRows}
                                    pagination={false}
                                >
                                    <div className="flex m-2 space-x-2 justify-end"></div>
                                </DataTableComponent>
                            </div>
                        </div>
                        {divisionData && divisionData.length > 0 && (
                            <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mt-4">
                                <div className="border-b flex justify-between items-center border-gray-200 bg-gray-50 px-6 py-3">
                                    <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                        <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                        </svg>
                                        Division Wise Summary
                                    </h2>
                                    <CustomOnlyDownloadExport
                                        defaultColumns={["division_name", "financial_year", "total_qty", "total_points", "total_value"]}
                                        buttonClassname="btn h-9 px-3 text-xs flex items-center justify-center font-semibold"
                                        fetchData={() => divisionData}
                                        filename="Division_Wise_Summary"
                                        label="Download Records"
                                    />
                                </div>
                                <div className="overflow-x-auto">
                                    <table className="w-full text-sm text-left">
                                        <thead className="bg-gray-50 text-gray-600 text-xs uppercase border-b">
                                            <tr>
                                                <th className="px-4 py-2 font-semibold text-gray-700">Division Name</th>
                                                <th className="px-4 py-2 font-semibold text-gray-700 text-center">Financial Year</th>
                                                <th className="px-4 py-2 font-semibold text-gray-700 text-right">Total Qty</th>
                                                <th className="px-4 py-2 font-semibold text-gray-700 text-right">Total Points</th>
                                                <th className="px-4 py-2 font-semibold text-gray-700 text-right">Total Value</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-100">
                                            {divisionData.map((row, idx) => (
                                                <tr key={idx} className="hover:bg-gray-50/50 transition-colors">
                                                    <td className="px-4 py-2 font-semibold text-gray-800">{row.division_name}</td>
                                                    <td className="px-4 py-2 text-center text-gray-600 font-medium">{row.financial_year}</td>
                                                    <td className="px-4 py-2 text-right text-gray-600 font-medium">
                                                        {parseFloat(row.total_qty || 0).toLocaleString('en-IN')}
                                                    </td>
                                                    <td className="px-4 py-2 text-right font-bold text-blue-600">
                                                        {formatter.format(Number(row.total_points || 0))}
                                                    </td>
                                                    <td className="px-4 py-2 text-right font-semibold text-green-600">
                                                        ₹{formatter.format(Number(row.total_value || 0))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </>
    );
};

export default BorosilUserHistorySearch;
